import React, { useEffect, useState } from "react";
import axios from "axios";
import BackHeader from "../BackHeader";
import MiniDrawer from "../Sidebar";
import ChangePassword from "./ChangePassword";
import "./style.css";
import Loader from "../../../Components/Loader";

const SecuritySetting = () => {
  const [data, setData] = useState();
  useEffect(async () => {
    const layout = await axios.get(
      "https://staging-cms-main.ipurvey.com/layout"
    );
    setData(layout.data);
  }, []);
  if (data) {
    return (
      <div className="accInfo_container">
        <div className="accInfo_md">
          <div className="accInfo_sd">
            <div className="db_left_content">
              <MiniDrawer />
            </div>
            <div className="accInfo_rigth_md">
              <div className="acc_back_link">
                <BackHeader head="SECURITY SETTING" link="/dashboard" />
              </div>
              <div className="acc_info_sd">
                <ChangePassword data={data} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else return <Loader />;
};

export default SecuritySetting;
